import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import { NotificationDtoKeysEnum } from '@zaoblako/shared/modules/notification/enums/notification-dto-keys.enum';
import { BusinessDtoKeysEnum } from '@zaoblako/shared/modules/business/enum/business-dto-keys.enum';
import { ProjectDtoKeysEnum } from '@zaoblako/shared/modules/project/enum/project-dto-keys.enum';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { HelpdeskDtoKeyEnum } from '@zaoblako/shared/modules/helpdesk/enum/helpdesk-dto-key.enum';
import { ReminderTypeEnum } from '@zaoblako/shared/modules/notification/enums/reminder.type.enum';
import { ReminderTypeEnumI18n } from '@zaoblako/shared/modules/notification/i18n/reminder.type.enum.i18n';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import type { HelpdeskTaskFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/helpdesk-task-find.dto';
import type { DealFindInterface } from '@zaoblako/shared/modules/business/dto/deal/deal-find.dto';
import type { ChecklistFindInterface } from '@zaoblako/shared/modules/project/dto/checklist/checklist-find.dto';
import type { ProjectFindInterface } from '@zaoblako/shared/modules/project/dto/project/project-find.dto';

import * as yup from 'yup';

export interface ReminderFindInterface {
  /** Unique identifier. Cannot be changed */
  id: number;
  /** Reminder creation date and time */
  created: Date;
  /** Reminder last update date and time */
  updated: Date;
  /** Reminder soft deletion date and time */
  deleted: Date;
  /** Reminder running date */
  date: Date;
  /** Reminder type */
  type: ReminderTypeEnum;
  /** Reminder creator - recipient of notifications in some cases and sender in other cases */
  user: UserFindInterface;
  /**
   * Target project checklist. If set, the reminder will notify those responsible
   * for the checklist on behalf of the user who created the reminder.
   */
  checklist?: ChecklistFindInterface;
  /** Target project. If set, the reminder will notify its creator of this project. */
  project?: ProjectFindInterface;
  /** Target deal. If set, the reminder will notify its creator of this deal. */
  deal?: DealFindInterface;
  /** Target HelpDesk task reminder. If set, the reminder will notify its creator of this task. */
  helpdeskTask?: HelpdeskTaskFindInterface;
}

/** Scheduled reminder notification */
export const ReminderFindDto = SerdeDtoClass.create<ReminderFindInterface>(NotificationDtoKeysEnum.REMINDER_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Обновлено',
    serializer: yup.date(),
  },
  deleted: {
    label: 'Удалён',
    serializer: yup.date(),
  },
  date: {
    label: 'Дата',
    serializer: yup.date(),
  },
  type: {
    label: 'Тип',
    serializer: commonEnumValidator(ReminderTypeEnum, ReminderTypeEnumI18n),
  },
  user: {
    label: 'Пользователь',
    nested: SecurityDtoKeysEnum.USER_FIND_DTO,
    serializer: (_, nested) => nested,
  },
  checklist: {
    optional: true,
    label: 'Контрольный список',
    nested: ProjectDtoKeysEnum.CHECKLIST_FIND_DTO,
    serializer: (_, nested) => nested,
  },
  project: {
    optional: true,
    label: 'Проект',
    nested: ProjectDtoKeysEnum.PROJECT_FIND_DTO,
    serializer: (_, nested) => nested,
  },
  deal: {
    optional: true,
    label: 'Сделка',
    nested: BusinessDtoKeysEnum.DEAL_FIND_DTO,
    serializer: (_, nested) => nested,
  },
  helpdeskTask: {
    optional: true,
    label: 'Заявка HD',
    nested: HelpdeskDtoKeyEnum.HELPDESK_TASK_FIND_DTO,
    serializer: (_, nested) => nested,
  },
});
